/**
 * Created by huzhongchun on 2018/4/20.
 */
const USER_INFO_UPDATE = 'USER_INFO_UPDATE';
const USER_PAGE_INFO_UPDATE = 'USER_PAGE_INFO_UPDATE';
const ROUTER_PATH_UPDATE = 'ROUTER_PATH_UPDATE';

const CALENDAR_INFO_UPDATE = 'CALENDAR_INFO_UPDATE';
const CALENDAR_DATA_UPDATE = 'CALENDAR_DATA_UPDATE';

const WORD_LEARN_UPDATE = 'WORD_LEARN_UPDATE';

//today info
const TODAY_INFO_UPDATE = 'TODAY_INFO_UPDATE';
const COMMON_INIT_DATA_UPDATE = 'COMMON_INIT_DATA_UPDATE';

const TREE_INFO_UPDATE = 'TREE_INFO_UPDATE';

//chicken
const CHICKEN_USER_INFO_UPDATE = 'CHICKEN_USER_INFO_UPDATE';

//meditation
const MEDITATION_USER_INFO_UPDATE = 'MEDITATION_USER_INFO_UPDATE';
const MEDITATION_TODAY_UPDATE = 'MEDITATION_TODAY_UPDATE';
const MEDITATION_ITEM_ID_UPDATE = 'MEDITATION_ITEM_ID_UPDATE';

//
const READ_PLAN_USER_INFO = 'READ_PLAN_USER_INFO';
const READ_PLAN_LIST_INFO = 'READ_PLAN_LIST_INFO';

// mall
const CARD_INFO_UPDATE = 'CARD_INFO_UPDATE';

//millionaire
const MILLIONAIRE_USER_INFO_UPDATE = 'MILLIONAIRE_USER_INFO_UPDATE';

//reading
const READING_USER_INFO_UPDATE = 'READING_USER_INFO_UPDATE';
const CALENDAR_USER_LIST = 'CALENDAR_USER_LIST';


//new vitality
const NEW_VITALITY_USER_INFO_UPDATE = 'NEW_VITALITY_USER_INFO_UPDATE';
const NEW_VITALITY_GLOBAL_DATA = 'NEW_VITALITY_GLOBAL_DATA';

//training
const TRAINING_USER_INFO_UPDATE = 'TRAINING_USER_INFO_UPDATE';
const TRAINING_COMMON_INIT_UPDATE = 'TRAINING_COMMON_INIT_UPDATE';
const TRAINING_TODAY_INFO_UPDATE = 'TRAINING_TODAY_INFO_UPDATE';
const TRAINING_CALENDAR_LIST = 'TRAINING_CALENDAR_LIST';
const TRAINING_CALENDAR_SELECTED_DAY_INFO = 'TRAINING_CALENDAR_SELECTED_DAY_INFO';
const TRAINING_CALENDAR_SELECTED_DATE = 'TRAINING_CALENDAR_SELECTED_DATE';
const TRAINING_USER_CENTER_INFO_UPDATE = 'TRAINING_USER_CENTER_INFO_UPDATE';
// 晚安短信
const READING_GOODNIGHT_USER_INFO_UPDATE = 'READING_GOODNIGHT_USER_INFO_UPDATE';

//redux-action类型
export const actionTypes = {
	USER_INFO_UPDATE,
	ROUTER_PATH_UPDATE,
	WORD_LEARN_UPDATE,
	CALENDAR_INFO_UPDATE,
	CALENDAR_DATA_UPDATE,
	TODAY_INFO_UPDATE,
	COMMON_INIT_DATA_UPDATE,
	USER_PAGE_INFO_UPDATE,
	TREE_INFO_UPDATE,
	CHICKEN_USER_INFO_UPDATE,
	MEDITATION_USER_INFO_UPDATE,
	MEDITATION_TODAY_UPDATE,
	CARD_INFO_UPDATE,
	MEDITATION_ITEM_ID_UPDATE,
	READ_PLAN_USER_INFO,
	READ_PLAN_LIST_INFO,
	MILLIONAIRE_USER_INFO_UPDATE,
	READING_USER_INFO_UPDATE,
	CALENDAR_USER_LIST,
	NEW_VITALITY_USER_INFO_UPDATE,
	NEW_VITALITY_GLOBAL_DATA,
	TRAINING_USER_INFO_UPDATE,
	TRAINING_COMMON_INIT_UPDATE,
	TRAINING_TODAY_INFO_UPDATE,
	TRAINING_CALENDAR_LIST,
	TRAINING_CALENDAR_SELECTED_DAY_INFO,
	TRAINING_CALENDAR_SELECTED_DATE,
	TRAINING_USER_CENTER_INFO_UPDATE,
	READING_GOODNIGHT_USER_INFO_UPDATE
};



// WEBPACK FOOTER //
// ./src/constants/constants.js